import Api from 'services/api';
import apiURLBuilder from 'core/apiURLBuilder';
import preLoaderActions from './preLoaderActions';
import { goToErrorsView } from './errorViewNavigation';

export const saveSignatureKey =
    ({ signatureKey, successCallback }) =>
    (dispatch, getState) => {
        const accessToken = getState().userProfile.accessToken;
        const request = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: { signatureKey },
        };

        dispatch(preLoaderActions.showPreLoader());

        const getSaveSignatureKeyURL = apiURLBuilder.getURL('saveSignatureKey');
        Api.post(getSaveSignatureKeyURL, request).then(
            response => {
                dispatch(preLoaderActions.hidePreLoader());
                successCallback(response.body?.score);
            },
            error => {
                dispatch(preLoaderActions.hidePreLoader());
                dispatch(goToErrorsView({ errorCode: error?.status, errorMessage: getSaveSignatureKeyURL }));
            }
        );
    };
